<!-- Left content - single projection point -->
<div
	class="lb-responsive-layout-left"
	[class.mobile]="isMobile()"
	[class.desktop]="!isMobile()"
	[class.open]="mobileMenuOpen()"
	[ngClass]="{ sticky: stickyLeft() && !isMobile() }"
>
	<ng-content select="[left-content]"></ng-content>
</div>

<!-- Backdrop for mobile -->
@if (isMobile() && mobileMenuOpen()) {
	<div class="lb-responsive-layout-backdrop" (click)="closeMobileMenu()"></div>
}

<!-- Right content -->
<div class="lb-responsive-layout-right" [class.mobile]="isMobile()" [class.desktop]="!isMobile()">
	<ng-content select="[right-content]"></ng-content>
</div>
